import { SubstitutionsManager } from "@JS/nn4m-settings";

class CustomSubstitutionsManager extends SubstitutionsManager {
  addSubstitution(key: string, value: string) {
    this.substitutions[key] = value;
  }
}

export const substitutionsManager = new CustomSubstitutionsManager();
